import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import { computed } from "vue";
import { artifactStore } from "@/hooks";
import { Typography, PanelCard, Separator } from "@/components/common";
import ArtifactNameDisplay from "./ArtifactNameDisplay.vue";


/**
 * Displays the selected node's body.
 */
const __default__ = {
  name: "ArtifactBody",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const artifact = computed(() => artifactStore.selectedArtifact);

const body = computed(() => artifact.value?.body.trim() || "");

const variant = computed(() =>
  artifact.value?.isCode ? "code" : "expandable"
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PanelCard), { borderless: "" }, {
    default: _withCtx(() => [
      (artifact.value)
        ? (_openBlock(), _createBlock(ArtifactNameDisplay, {
            key: 0,
            artifact: artifact.value,
            "display-type": "",
            "display-tooltip": "",
            "is-header": "",
            "data-cy-name": "text-selected-name",
            "data-cy-type": "text-selected-type"
          }, null, 8, ["artifact"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(Separator), {
        b: "2",
        t: "1"
      }),
      _createVNode(_unref(Typography), {
        "default-expanded": "",
        "collapse-length": 0,
        variant: variant.value,
        el: "p",
        class: "full-width",
        value: body.value
      }, null, 8, ["variant", "value"])
    ]),
    _: 1
  }))
}
}

})